import type { AllRouteEndpoints } from "../routeTypes";

export const invalidationCacheKeys: AllRouteEndpoints[] = ["/apps/approval_settings", "/apps/app_group"];
